// Import Packages
import React, { useCallback, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

// Import Pages
import ShortCutSection from '../../shortCutSection/ShortCutSection';
import { alertState, activeItemsAtom, saveAvailable, changedFields, desktopActiveItemsAtom, baseOrigin, activeAutom } from '../../../../../../recoil-store/recoil-state';


import TabDialog from '../detailTabs/TabDialog';
import Item from './item/Item';
import TriggerModal from '../triggerModal/TriggerModal';


// Import Icons
import RoiIcon from '../../../../../../assets/icons/roi-icon.svg'
import DiagramIcon from '../../../../../../assets/icons/diagram-icon.svg'

// Import CSS
import './DropArea.css';
import {
    changeOrder,
    findChildScopeById,
    findChildDesktopActionById,
    findParentActionById,
    findIfLibraryExist,
    findActionById
} from "../../../../../../helpers/helper";

// Import Helper
import { handleRedo, handleUndo, handleUpdate } from '../../../../../../helpers/flowHistory';
import { isJSONDifferent, addDifference, removeDifference, addDifferenceBySet } from '../../../../../../helpers/helper';

// Import Services
import AutomService from '../../../../../../services/AutomService/AutomService';

const DropArea = React.memo(({
    automDetail,
    setAutomDetail,
    setTriggerDetail,
    handleTrigger,
    handleDragStart,
    isFocused,
    setDetailTabs,
    debuggingStart,
    openRunningModal,
    setShowRightArea,
    setShowTriggerRightArea,
    setDebuggingExpand,
    debuggingExpand, handleDragEnd,
    handleRoi, handleDrag,
    detailTabs, handleDrop,
    setTabFilter,
    handleDiagramBuilder,
    findAndUpdateItem,
    isEhFlow,
    setActiveItem,
    handleExport,
    handleImport,
    handleSlowMotion,
    handleErrorOpenClick,
    handleErrorCloseClick,
    variables,
    setOpenVariable,
    reCheck,
    setReCheck,
    openResetTriggerConfiguration,
    automaticallyVariableCreation,
    setTriggerModal,
    setOpenSchedule,
    automaticallyWhatsappVariableCreation,
    getVariables,
    updateVariableByItemId,
    savedFlow,
    isDesktopRecorder,
    handleActions,
    desktopActionsEditDialog,
    handleDeleteAction,
    changeLabelField,
    resetWPSession, setIsWhatsappExist, setIsMSTeamsExist,
    setActions,
    handleOpenErrorHandlingAutom,
    devMode,
}) => {
    const { t } = useTranslation();
    const [scale, setScale] = useState(1);
    const [dialog, setDialog] = useState(null);
    const [triggerOffSet, setTriggerOffSet] = useState(null);
    const [openTriggerConfigure, setOpenTriggerConfigure] = useState(false);
    const [activeItems, setActiveItems] = useRecoilState(activeItemsAtom)
    const [desktopActiveItems, setDesktopActiveItems] = useRecoilState(desktopActiveItemsAtom)
    const ruleLabel = "MESSAGES.AUTOMS.RULE.";
    const triggerStaticTriggerLabel = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC.TRIGGERS."
    const setAlert = useSetRecoilState(alertState);
    const setSaveAvailable = useSetRecoilState(saveAvailable);
    const setMainAutomDetail = useSetRecoilState(activeAutom);
    //const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
    const setChangeFields = useSetRecoilState(changedFields);
    // const copiedItem = useRecoilValue(copiedItemState);
    const base_origin = useRecoilValue(baseOrigin);

    useEffect(() => {
        // This function centers the start of an autom.
        handleScreen()
    }, [])

    const addItem = (id, items, newItem, direction, directionFlag, isFirstChild, isMove, bulk) => {
        let matched = false;
        items.forEach((item, index) => {
            if (item.id === id) {
                matched = true;
                if (isFirstChild) {
                    if (item.children) {
                        item.children = [newItem, ...item.children];
                    } else {
                        item.children = [newItem];
                    }
                } else {
                    if (newItem.name === 'ELSE' && items.length - 1 !== index) {
                        //return false;
                        matched = false;
                        return false;
                    }
                    items.splice(index + 1, 0, { ...newItem, conditionGroupId: item.conditionGroupId });
                }
                return;
            }
            if (directionFlag && item.children && item.children[0]?.id === id) {
                item.flow = direction;
            }
            if (!matched && item.id !== id && item.children) {
                matched = addItem(id, item.children, newItem, direction, directionFlag, isFirstChild, isMove);
                if (matched) {
                    return true;
                }
            }
        });
        if (items && items.length) {
            changeOrder(items, 0);
        }

        // if (newItem.name === 'CONDITION') newItem = newItem.children[0];
        // if (!bulk && !isMove)
        //     setAutomDetail({
        //         ...automDetail, items, activeItem: [{
        //             ...newItem,
        //             actionName: newItem.action_name,
        //             libraryName: newItem.library_name,
        //             libraryLabel: newItem.library_label,
        //         }]
        //     });
        return matched;
    };

    function removeItem(id, items, i) {
        return items.map(item => {
            return { ...item };
        }).filter(item => {
            if ('children' in item) {
                if (i && item.children.find(x => x.id === id)) return false;
                item.children = removeItem(id, item.children, i);
            }
            return item.id !== id;
        });
    }

    function RemoveAndActiveItem(id, items, action, node = {}) {
        items.map((item, k) => {
            if (item.id === id) {
                if (items[k - 1]) {
                    action.push(items[k - 1]);
                } else {
                    action.push(node);
                }
            }
            if ('children' in item) {
                RemoveAndActiveItem(id, item.children, action, item);
            }
            return item;
        });
    }

    const checkUpdateRules = (autom, prevItem, draggingItem, direction, isFirstChild, item, id, copy, group, selectedItem, isMove) => {
        // TODO CHECK AND HANDLE THIS METHOD
        if (draggingItem === 'START' || draggingItem === 'STOP' || draggingItem === 'TRIGGER') {
            return false; // rule: start and stop cannot be draggable item
        }

        // MY CHATGPT Library Rules Start

        // Message Cannot be dragged outside of Thread Scope
        if ((item.library_label === "MYCHATGPT" && draggingItem === 'MESSAGE') && group?.action_name !== 'THREAD-SCOPE') {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'MESSAGE-ONLY-IN-THREAD-SCOPE'), severity: 'info' }));
            return false;
        }

        // Run Cannot be dragged outside of Thread Scope
        if ((item.library_label === "MYCHATGPT" && draggingItem === 'RUN') && group?.action_name !== 'THREAD-SCOPE') {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'RUN-ONLY-IN-THREAD-SCOPE'), severity: 'info' }));
            return false;
        }

        /* WHATSAPP Library Rules Start*/
        if (debuggingStart) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'OPERATIONS-NOT-PERMITTED-ON-DEBUGGING'), severity: 'info' }));
            return false;
        }

        // there can only be 1 LIST-SCOPE action at the same level
        if (draggingItem === 'LIST-SCOPE' && group?.children?.filter(x => x.action_name === "LIST-SCOPE").length > 0) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ONLY-ONE-LIST-SCOPE-SAME-LEVEL'), severity: 'info' }));
            return false;
        }

        //there can only be 1 BUTTON-SCOPE action at the same level
        if (draggingItem === 'BUTTON-SCOPE' && group?.children?.filter(x => x.action_name === "BUTTON-SCOPE").length > 0) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ONLY-ONE-BUTTON-SCOPE-SAME-LEVEL'), severity: 'info' }));
            return false;
        }

        // Only LIST-ITEM or DYNAMIC-LIST can be added to LIST-SCOPE
        if (group?.action_name === 'LIST-SCOPE' && draggingItem !== 'LIST-ITEM' && draggingItem !== 'DYNAMIC-LIST') {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ONLY-LIST-ITEM-OR-DYNAMIC-LIST-ADDED-TO-LIST-SCOPE'), severity: 'info' }));
            return false;
        }

        // Only BUTTON-ITEM can be added to BUTTON-SCOPE
        if (group?.action_name === 'BUTTON-SCOPE' && draggingItem !== 'BUTTON-ITEM') {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ONLY-BUTTON-ITEM-ADDED-BUTTON-SCOPE'), severity: 'info' }));
            return false;
        }

        // LIST-SCOPE action can only be dragged into TEXT, LIST-ITEM, DYNAMIC-LIST, BUTTON-ITEM actions from whatsapp library
        if (draggingItem === 'LIST-SCOPE' &&
            (group?.library_name === 'WHATSAPP' && group?.action_name !== 'TEXT' && group?.action_name !== 'LIST-ITEM' &&
                group?.action_name !== 'DYNAMIC-LIST' && group?.action_name !== 'BUTTON-ITEM')) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'LIST-SCOPE-ONLY-DRAGGED-INTO-WHATSAPP-LIBRARIES'), severity: 'info' }));
            return false;
        }

        // BUTTON-SCOPE action can only be dragged into TEXT, BUTTON-ITEM, DYNAMIC-LIST actions from whatsapp library
        if (draggingItem === 'BUTTON-SCOPE' &&
            (group?.library_name === 'WHATSAPP' && group?.action_name !== 'TEXT' && group?.action_name !== 'BUTTON-ITEM' && group?.action_name !== 'DYNAMIC-LIST' && group?.action_name !== 'LIST-ITEM')) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'BUTTON-SCOPE-ONLY-DRAGGED-INTO-WHATSAPP-LIBRARIES'), severity: 'info' }));
            return false;
        }

        // BUTTON-ITEM can only be in BUTTON-SCOPE
        if (draggingItem === 'BUTTON-ITEM' && group?.action_name !== 'BUTTON-SCOPE') {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'BUTTON-ITEM-ONLY-IN-BUTTON-SCOPE'), severity: 'info' }));
            return false;
        }

        // LIST-ITEM can only be in LIST-SCOPE
        if (draggingItem === 'LIST-ITEM' && group?.action_name !== 'LIST-SCOPE') {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'LIST-ITEM-ONLY-IN-LIST-SCOPE'), severity: 'info' }));
            return false;
        }

        // DYNAMIC-LIST can only be in LIST-SCOPE
        if (draggingItem === 'DYNAMIC-LIST' && group?.action_name !== 'LIST-SCOPE') {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'DYNAMIC-LIST-ONLY-IN-LIST-SCOPE'), severity: 'info' }));
            return false;
        }

        // LIST-SCOPE, BUTTON-SCOPE and SEND-MEDIA cannot be dragged into the REPEAT action
        if (group?.action_name === "REPEAT" &&
            (draggingItem === "LIST-SCOPE" ||
                draggingItem === "BUTTON-SCOPE" ||
                draggingItem === "SEND-MEDIA")) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'REPEAT-ACTION-CANNOT-BE-DRAGGED-MESSAGE'), severity: 'info' }));
            return false;
        }

        // Up to 10 LIST-ITEM actions can be dragged into the LIST-SCOPE action
        if (draggingItem === 'LIST-ITEM' && group?.action_name === 'LIST-SCOPE' && group?.children?.length > 9) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'UP-TO-TEN-LIST-ITEM-ACTIONS-CAN-BE-DRAGGED'), severity: 'info' }));
            return false; // rule: start and stop cannot be draggable item
        }

        // Up to 3 BUTTON-ITEM actions can be dragged into the BUTTON-SCOPE action
        if (draggingItem === 'BUTTON-ITEM' && group?.action_name === 'BUTTON-SCOPE' && group?.children?.length > 2) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'UP-TO-THREE-BUTTON-ITEM-ACTIONS-CAN-BE-DRAGGED'), severity: 'info' }));
            return false; // rule: start and stop cannot be draggable item
        }

        // there can be only 1 DYNAMIC-LIST at the same level
        if (draggingItem === 'DYNAMIC-LIST' && (group?.children?.filter(x => x.action_name === 'DYNAMIC-LIST').length > 0 ||
            group?.children?.filter(x => x.action_name === 'LIST-ITEM').length > 0)) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ONLY-ONE-DYNAMIC-LIST-SAME-LEVEL'), severity: 'info' }));
            return false;
        }

        // LIST-ITEM action cannot be dragged if there is the same level of DYNAMIC-LIST action
        if (draggingItem === 'LIST-ITEM' && group?.children?.filter(x => x.action_name === 'DYNAMIC-LIST').length > 0) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'LIST-ITEM-CANNOT-BE-DRAGGED-SAME-LEVEL-DYNAMIC-LIST'), severity: 'info' }));
            return false;
        }
        /* WHATSAPP Library Rules END*/


        // if (draggingItem === 'BUTTON-ITEM' && group?.action_name === 'BUTTON-SCOPE' && group?.children?.length > 2) {
        //     return false; // rule: start and stop cannot be draggable item
        // }

        // if (group?.children?.length > 0 && group?.children?.filter(x => x.name === "LIST-SCOPE").length > 0 && draggingItem === "LIST-SCOPE") {
        //     return false;
        // }

        // if (!group &&
        //     (draggingItem === "LIST-ITEM" ||
        //         draggingItem === "DYNAMIC-LIST" ||
        //         draggingItem === "BUTTON-ITEM")) {
        //     return false;
        // }

        // if (group?.action_name === "REPEAT" &&
        //     (draggingItem === "LIST-SCOPE" ||
        //         draggingItem === "BUTTON-SCOPE")) {
        //     return false;
        // }

        // if (group?.action_name === 'LIST-SCOPE' && (draggingItem !== 'LIST-ITEM' && draggingItem !== 'DYNAMIC-LIST')) {
        //     return false; // rule: start and stop cannot be draggable item
        // }

        // if (group?.action_name === 'BUTTON-SCOPE' && draggingItem !== 'BUTTON-ITEM') {
        //     return false; // rule: start and stop cannot be draggable item
        // }

        // if (draggingItem === 'LIST-ITEM' && group?.action_name === 'LIST-SCOPE' && group?.children?.length > 9) {
        //     return false; // rule: start and stop cannot be draggable item
        // }

        // if (draggingItem === 'BUTTON-ITEM' && group?.action_name === 'BUTTON-SCOPE' && group?.children?.length > 2) {
        //     return false; // rule: start and stop cannot be draggable item
        // }

        // if ((draggingItem === 'FIND-AND-INPUT' ||
        //     draggingItem === 'FIND-AND-CLICK' ||
        //     draggingItem === 'GET-TEXT' ||
        //     draggingItem === 'GET-IMAGE' ||
        //     draggingItem === 'PAGINATION' ||
        //     draggingItem === 'HOVER') && group?.action_name !== 'SCOPE' && group?.action_name !== "PAGINATION-ITEM" && group?.action_name !== "IF") {
        //     return false; // rule: start and stop cannot be draggable item
        // }
        if (item.id === id && item.library_label !== "DESKTOPACTIONS" && !isDesktopRecorder && item.children?.length > 0) {
            let childDesktopAction;
            childDesktopAction = findChildDesktopActionById(item.children)
            if (childDesktopAction?.actionName) {
                setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'CANNOT-DRAG-ANY-ACTION-INSIDE-OF-SCOPE-ON-MAIN-FLOW'), severity: 'info' }));
                return false; // rule: Any actions cnat paste itself while inside scope on main flow.
            }
        }
        if (draggingItem !== 'SCOPE' && item.library_label === "DESKTOPACTIONS" && isMove) {
            const parentScope = findParentScopeById(item.item_id, autom.items, true)
            if (parentScope.actionName && group?.actionName === "SCOPE" && parentScope.id !== group?.id) {
                setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'DESKTOP-ACTIONS-CANNOT-MOVE-EXCEPT-OWN-PARENT-SCOPE'), severity: 'info' }));
                return false; // rule: Desktop actions cannowt move anywhere except own parent scope
            }
            else {
                const grandParentScope = findParentScopeById(!group ? selectedItem.item_id : group?.item_id, autom.items, true)
                if (parentScope.actionName && grandParentScope.actionName && parentScope.id !== grandParentScope.id) {
                    setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'DESKTOP-ACTIONS-CANNOT-MOVE-EXCEPT-OWN-PARENT-SCOPE'), severity: 'info' }));
                    return false; // rule: Desktop actions cannowt move anywhere except own parent scope
                }
            }
        }
        if (item.children?.length > 0 && draggingItem !== "SCOPE" && isMove) {
            let childDesktopAction;
            childDesktopAction = findChildDesktopActionById(item.children)
            if (childDesktopAction?.actionName) {
                const parentScope = findParentScopeById(item.item_id, autom.items, true)
                if (parentScope.actionName && group?.actionName === "SCOPE" && parentScope.id !== group?.id) {
                    setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'GROUPABLE-ACTIONS-CANNOT-MOVE-WHILE-HAS-CHILD-DESKTOP-ACTIONS'), severity: 'info' }));
                    return false; // rule: Groupable actions cannot move anywhere while has a child desktop actions except inside own parent Scope
                }
                else {
                    const grandParentScope = findParentScopeById(!group ? selectedItem.item_id : group?.item_id, autom.items, true)
                    if (parentScope.actionName && grandParentScope.actionName && parentScope.id !== grandParentScope.id) {
                        setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'GROUPABLE-ACTIONS-CANNOT-MOVE-WHILE-HAS-CHILD-DESKTOP-ACTIONS'), severity: 'info' }));
                        return false; // rule: Groupable actions cannot move anywhere while has a child Desktop Actions except inside own parent Scope
                    }
                }
            }
        }
        // if (item.id === id && item.library_label !== "DESKTOPACTIONS") {
        //     return true; // rule: groupable element cannot be enclosed
        // }
        if (direction === 'column' && draggingItem !== 'ELSE' && draggingItem !== 'ELSEIF' && draggingItem !== 'LIST-ITEM' && draggingItem !== 'BUTTON-ITEM') {
            return false; // rule: elements other than else&elseif cannot be added to horizontal line
        }

        if (isFirstChild && (draggingItem === 'ELSE' || draggingItem === 'ELSEIF')) {
            return false; // rule: else and elseif cannot be added as a first child
        }

        if (!isFirstChild && (prevItem === 'IF' || prevItem === 'ELSEIF') && draggingItem !== 'ELSE' && draggingItem !== 'ELSEIF') {
            return false; // rule:
        }
        if (prevItem !== 'IF' && prevItem !== 'ELSEIF' && (draggingItem === 'ELSE' || draggingItem === 'ELSEIF')) {
            return false; // rule:
        }
        if (item.type === 'groupable' && item.children) {
            let flatten = item.children.flat();
            if (flatten.findIndex(element => element.id === id) > -1)
                return false; // rule: parent element cannot be moved into its own child
        }
        if (draggingItem === 'PAGINATION' && group?.actionName !== "SCOPE") {
            return false; // rule: Pagination only add inside of Scope
        }
        if (draggingItem === 'PAGINATION-ITEM' && group?.actionName !== 'PAGINATION') {
            return false; // rule: Pagination item only add inside of Pagination
        }
        if ((draggingItem !== 'PAGINATION-ITEM' && draggingItem !== 'POST-PAGINATION') && group?.actionName === 'PAGINATION') {
            return false; // rule: Pagination only has Pagination Item
        }
        if (draggingItem === 'PAGINATION' && !isFirstChild) {
            return false; // rule: Pagination only can be firstChild
        }
        if (group?.actionName === "SCOPE" && !isDesktopRecorder) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'CANNOT-DRAG-ANY-ACTION-INSIDE-OF-SCOPE-ON-MAIN-FLOW'), severity: 'info' }));
        }
        if (item.fields && item.fields.errorFlow && item.fields.errorFlow.value && copy && isEhFlow) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'CANNOT-COPY-ERROR-HANDLING-ACTION'), severity: 'info' }));
            return false; // rule: If action has a error handling cannot pase inside error handling Autom
        }
        if ((group || copy) && (item?.children?.length > 0 || (group?.children?.length > 0 && group?.actionName)) && !isDesktopRecorder) {
            const parentScope = findParentScopeById(!group ? selectedItem.item_id : group.item_id, autom.items, true)
            if (parentScope.actionName) {
                setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'CANNOT-DRAG-ANY-ACTION-INSIDE-OF-SCOPE-ON-MAIN-FLOW'), severity: 'info' }));
                return false; // rule: Cant add Scope actions into a any parent Scope action
            }
        }
        if (isFirstChild && group?.actionName === "SCOPE" && group?.children && group?.children.length > 0 && group?.children[0].actionName === 'PAGINATION') {
            return false; // rule: Cant add any action upside pagination action
        }
        if (draggingItem === 'SCOPE' && group?.actionName === "SCOPE") {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'SCOPE-CANNOT-BE-DRAGGED-INSIDE-OF-SCOPE'), severity: 'info' }));
            return false; // rule: Cant add Scope actions into a Scope action
        }
        if (draggingItem === 'SCOPE' && group?.item_id) {
            const parentScope = findParentScopeById(group.item_id, autom.items, true)
            // findParentScopeById(group.item_id, autom.items, true).then(parentScope => {
            //     if (parentScope) {
            //         setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'SCOPE-CANNOT-BE-DRAGGED-INSIDE-OF-GRAND-PARENT-SCOPE'), severity: 'error' }));
            //         return false; // rule: Cant add Scope actions into a any parent Scope action
            //     }
            // })
            if (parentScope.actionName) {
                setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'SCOPE-CANNOT-BE-DRAGGED-INSIDE-OF-GRAND-PARENT-SCOPE'), severity: 'info' }));
                return false; // rule: Cant add Scope actions into a any parent Scope action
            }
        }
        if (draggingItem !== 'SCOPE' && item.library_label === "DESKTOPACTIONS" && group?.actionName !== "SCOPE") {
            if (group?.item_id) {
                const parentScope = findParentScopeById(group.item_id, autom.items, true)
                if (parentScope?.actionName !== "SCOPE") {
                    setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ANY-DESKTOP-ACTIONS-CANNOT-ADD-EXPECT-INSIDE-OF-SCOPE'), severity: 'info' }));
                    return false; // rule: Cant add Scope actions into a any parent Scope action
                }
            }
        }
        // if (draggingItem !== 'SCOPE' && item.library_label === "DESKTOPACTIONS" && !group?.item_id && !isDesktopRecorder) {
        //     setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ANY-DESKTOP-ACTIONS-CANNOT-ADD-EXPECT-INSIDE-OF-SCOPE'), severity: 'error' }));
        //     return false // rule: Desktop actions cannot drag or paste inside of any actions expect Scope action
        // }
        if (draggingItem !== 'SCOPE' && item.library_label === "DESKTOPACTIONS" && (!group?.item_id && id !== item.id)) {
            if (selectedItem && isDesktopRecorder) {
                const parentScope = findParentScopeById(selectedItem.item_id, autom.items, true)
                if (!parentScope.actionName) {
                    setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ANY-DESKTOP-ACTIONS-CANNOT-ADD-EXPECT-INSIDE-OF-SCOPE'), severity: 'info' }));
                    return false // rule: Desktop actions cannot drag or paste inside of any actions expect Scope action
                }
            }
            else {
                setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ANY-DESKTOP-ACTIONS-CANNOT-ADD-EXPECT-INSIDE-OF-SCOPE'), severity: 'info' }));
                return false // rule: Desktop actions cannot drag or paste inside of any actions expect Scope action
            }

        }
        if (draggingItem !== 'SCOPE' && item.library_label === "DESKTOPACTIONS" && !isDesktopRecorder) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ANY-DESKTOP-ACTIONS-CANNOT-ADD-EXPECT-INSIDE-OF-SCOPE'), severity: 'info' }));
            return false // rule: Desktop actions cannot drag or paste inside of any actions expect Scope action
        }
        if (group?.actionName === "SCOPE" && item.children?.length > 0) {
            let childScope;
            childScope = findChildScopeById(item.children)
            if (childScope.actionName) {
                setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ACTION-CANNOT-BE-DRAGGED-INSIDE-OF-SCOPE-WHILE-HAVE-CHILD-SCOPE'), severity: 'info' }));
                return false
            }
        }
        if (group?.actionName && item.children?.length > 0) {
            const parentScope = findParentScopeById(group.item_id, autom.items, true)
            if (parentScope?.actionName) {
                let childScope;
                childScope = findChildScopeById(item.children)
                if (childScope.actionName) {
                    setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ACTION-CANNOT-BE-DRAGGED-INSIDE-OF-SCOPE-WHILE-HAVE-CHILD-SCOPE'), severity: 'info' }));
                    return false
                }
            }
        }
        if (draggingItem === 'SCOPE' && copy && !group) {
            const parentScope = findParentScopeById(selectedItem.item_id, autom.items, true)
            if (parentScope?.actionName === "SCOPE") {
                setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'SCOPE-CANNOT-BE-DRAGGED-INSIDE-OF-SCOPE'), severity: 'info' }));
                return false; // rule: Cant add Scope actions into a any parent Scope action
            }
        }
        if (copy && !group && item.children?.length > 0) {
            const parentScope = findParentScopeById(selectedItem.item_id, autom.items, true)
            if (parentScope?.actionName) {
                let childScope;
                childScope = findChildScopeById(item.children)
                if (childScope.actionName) {
                    setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ACTION-CANNOT-BE-DRAGGED-INSIDE-OF-SCOPE-WHILE-HAVE-CHILD-SCOPE'), severity: 'info' }));
                    return false
                }
            }
        }
        if (item.children?.length > 0 && draggingItem !== "SCOPE") {
            let childDesktopAction;
            // childScope = findChildScopeById(item.children)
            // if (childScope) {
            //     childDesktopAction = findChildDesktopActionById(childScope.children)
            // }
            childDesktopAction = findChildDesktopActionById(item.children)
            if (childDesktopAction?.actionName) {
                if (group?.item_id || copy) {
                    if (group?.actionName === "SCOPE") { }
                    else if (group?.actionName !== "SCOPE" || copy) {
                        const parentScope = findParentScopeById(!group ? selectedItem.item_id : group?.item_id, autom.items, true)
                        if (!parentScope.actionName) {
                            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ACTION-CANNOT-BE-DRAGGED-ANYWHERE-EXPECT-INSIDE-OF-SCOPE-WHILE-HAVE-CHILD-DESKTOP-ACTION'), severity: 'info' }));
                            return false
                        }
                    }
                }
                else {
                    setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ACTION-CANNOT-BE-DRAGGED-ANYWHERE-EXPECT-INSIDE-OF-SCOPE-WHILE-HAVE-CHILD-DESKTOP-ACTION'), severity: 'info' }));
                    return false
                }
            }
        }
        if (autom.type === "Action" && copy && (["MICROSOFT-TEAMS", "WHATSAPP", "DESKTOP-ACTIONS"].includes(item.library_name) || item.library_label.includes("CUSTOM"))) {
            setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'ACTION-CANNOT-BE-COPY-IN-THIS-TYPE-OF-AUTOM'), severity: 'info' }));
            return false
        }
        // if (item.library_label === "DESKTOPACTIONS" && group.item_id) {
        //     const parentScope = findParentScopeById(group.item_id, automDetail.items, true)
        //     if (!parentScope) {
        //         setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'SCOPE-CANNOT-BE-DRAGGED-INSIDE-OF-GRAND-PARENT-SCOPE'), severity: 'error' }));
        //         return false; // rule: Cant add Scope actions into a any parent Scope action
        //     }
        // }
        return !(group?.actionName === "SCOPE" && !isDesktopRecorder);


    };
    function findParentScopeById(item_id, items, root) {

        let foundItem = {};
        for (let item of items) {
            if (item.item_id === item_id) {
                if (root) {
                    foundItem = { children: items };
                } else {
                    foundItem = { found: true };
                }
                break;
            } else if (item.children) {
                foundItem = findParentScopeById(item_id, item.children, false);
                if (foundItem.found) {
                    if (item.actionName === 'SCOPE') {
                        foundItem = item;
                    }
                    break;
                } else if (foundItem.item_id) {
                    break;
                }
            }
        };
        return foundItem
    }

    // Checking the rule that the 'else' action cannot be moved between if and else. Only call this method for 'else' action
    const elseActionRule = (id, items) => {
        let result = true;
        items.forEach((item, index) => {
            if (item.id === id) {
                if (items.length - 1 !== index) {
                    result = false
                    return;
                }
            } else if (item.children) {
                if (!elseActionRule(id, item.children)) {
                    result = false
                    return;
                }
            }
        });
        return result;
    }

    const updateIDs = (items, copy) => {
        if (Array.isArray(items)) {
            for (let item of items) {
                // item.item_id = copy ? uuidv4() : item.item_id;
                item.id = uuidv4();

                if (copy && item.item_id) {
                    item.item_id = uuidv4()
                    handleActions(item)
                }
                if (item.children?.length > 0) {
                    updateIDs(item.children, copy);
                }
            }
        }
    };

    // Finding Parent Condition for "if" action
    const findParentCondition = (id, items) => {
        let result = { matched: false, assigned: false, condition: {} };
        for (let item of items) {
            if (item.id === id) {
                result.matched = true;
                break;
            } else if (item.children) {
                const resp = findParentCondition(id, item.children)
                if (resp.assigned) {
                    result.assigned = true;
                    result.condition = resp.condition;
                    result.matched = true;
                    break;
                } else if (resp.matched) {
                    result.condition = { id: item.id, conditionGroupId: item.conditionGroupId, flow: item.flow };
                    result.assigned = true;
                    result.matched = true;
                    break;
                }
            }
        }
        return result;
    }
    const updateItems = useCallback((index, autom, name, id, direction, isFirstChild, copy, bulk, modified, group, selectedItem) => {
        setShowTriggerRightArea(false);
        let currentItem;
        if (copy) {
            currentItem = JSON.parse(localStorage.getItem('copiedItem'));
            if (currentItem.item.libraryName === "WHATSAPP") {
                setIsWhatsappExist(true);
            }
            if (currentItem.item.libraryName === "MICROSOFT-TEAMS") {
                setIsMSTeamsExist(true);
            }
            // currentItem = copiedItem.item ? copiedItem : undefined
            let hostName = JSON.parse(localStorage.getItem('copiedItem'));
            if (!currentItem && hostName.baseOrigin !== base_origin) {
                return;
            }
        } else {
            let ditem = localStorage.getItem('dragItem')
            if (!ditem) {
                return;
            } else {
                currentItem = JSON.parse(ditem);
            }

            //currentItem = JSON.parse(localStorage.getItem('dragItem'));
            localStorage.removeItem('dragItem');
        }
        let item = bulk || currentItem?.item[0] || currentItem?.item; // dragging item
        let isMove = currentItem?.isMove;
        let directionFlag = false;
        // if (item && item.id !== id) {

        if (item && (copy || (item.id !== id))) {

            item = JSON.parse(JSON.stringify(item));
            let addableFlag = checkUpdateRules(autom, name, item.action_name, direction, isFirstChild, item, id, copy, group, selectedItem, isMove);
            if (addableFlag) {

                let items = modified ? modified : JSON.parse(JSON.stringify(autom.items));

                let newItem = {
                    ...item,
                    name: item.action_name,
                    type: item.type ? item.type : item.flow_behavior?.includes('groupable') ? 'groupable' : 'standard',
                    item_id: copy ? uuidv4() : item.item_id,
                    // When Action is moved keeping its id. Otherwise, gives new id.
                    id: isMove ? item.id : uuidv4(),
                    hidden: false
                };

                if (newItem?.fields) {
                    if (
                        (newItem.library_label === "WHATSAPP" && (newItem.action_label === "LISTITEM" || newItem.action_label === "BUTTONITEM" || newItem.action_label === "DYNAMICLIST"))
                        ||
                        (newItem.library_label === "MICROSOFTTEAMS" && newItem.action_label === "SENDCARD")
                    ) {
                        const variableName = `##${newItem.action_label.toLowerCase()}_${newItem.item_id.replaceAll('-', '')}##`
                        automaticallyWhatsappVariableCreation(newItem.item_id, newItem.action_label)

                        newItem.fields.set = {
                            conditions: [],
                            value: variableName
                        }
                    }

                }

                if (copy) {
                    handleActions(newItem)
                    if (newItem.children) {
                        updateIDs(newItem.children, copy);
                    }
                }
                let parentCondition;
                if (['IF', 'ELSE', 'ELSEIF'].includes(newItem.name)) {

                    // Todo HANDLE CONDITION GROUP CREATION

                    if (newItem.name === 'IF') {
                        // Finding "if" actions parent condition
                        if (isMove) {
                            let rst = findParentCondition(item.id, items);
                            if (rst.assigned) {
                                parentCondition = rst.condition;
                            }
                        }
                        // Checking "if" action moving down to itself
                        if (isMove && parentCondition?.id === id) return
                        // Creating conditionGroupId for some "else","else if" moving rules and changing their conditionGroupId or keep it
                        let conditionGroupId = parentCondition?.conditionGroupId ? parentCondition.conditionGroupId : uuidv4();
                        newItem.conditionGroupId = conditionGroupId;

                        let conditionItem = {
                            action_name: 'CONDITION',
                            name: 'CONDITION',
                            type: 'condition',
                            // item_id: uuidv4(),
                            id: parentCondition?.id ? parentCondition.id : uuidv4(),
                            conditionGroupId: conditionGroupId,
                            flow: 'rowCol',
                            children: [newItem],
                            flow_behavior: ['vertical', 'groupable'],
                            hidden: false
                        };
                        newItem = conditionItem;
                    } else {
                        directionFlag = true;
                    }
                }
                // Checking "else" actions for cannot be moved to the middle of "if" and "else if"
                if (item.action_name === 'ELSE' && !isFirstChild) {
                    if (!elseActionRule(id, items)) {
                        return
                    }
                }
                if ((item.action_name === 'ELSEIF' || item.action_name === 'ELSE') && name === "IF" && copy) {
                    // let rst = findParentCondition(id, items);
                    // direction = rst.condition?.flow
                    direction = "column"
                }
                if (isMove) {
                    // Remove moved action and returns the remaining items
                    items = removeItem(parentCondition?.id ? parentCondition.id : item.id, items);
                    // items içinde id yoksa hata ver....
                }
                if (copy) {
                    handleActions(newItem)
                }

                if (addItem(id, items, newItem, direction, directionFlag, isFirstChild, isMove, bulk)) {
                    if (newItem.name === 'CONDITION') newItem = newItem.children[0];
                    //const cfTemp = JSON.parse(JSON.stringify(changedFieldsState));
                    if (isMove) {
                        //if (bulk) items = modifiedItems;
                        // setAutomDetail({ ...automDetail, items: modifiedItems, activeItem: [newItem] });
                        setAutomDetail({ ...autom, items });
                        if (isDesktopRecorder) {
                            setDesktopActiveItems([newItem])
                        }
                        else {
                            setActiveItems([newItem])
                        }
                        isEhFlow ? handleUpdate(items, undefined, undefined, "errorHistory", autom.errorHandlingId) : handleUpdate(items)
                        let modifiedItemsClone = JSON.parse(JSON.stringify(items));
                        changeOrder(modifiedItemsClone, 0);
                        //  const isFlowChanged = isJSONDifferent(modifiedItemsClone, savedFlow)
                        addDifferenceBySet(newItem, "moveItem", setChangeFields, setSaveAvailable);
                        // if (isFlowChanged) {
                        //     addDifference(cfTemp, newItem, "move", setChangeFields, setSaveAvailable);
                        //     // setSaveAvailable(true); //
                        // } else {
                        //     removeDifference(cfTemp, newItem, "move", setChangeFields, setSaveAvailable);
                        //     // setSaveAvailable(false);
                        // }
                    } else {
                        if (!bulk) {
                            changeOrder(items, 0);
                            //  const isFlowChanged = isJSONDifferent(items, savedFlow)
                            addDifferenceBySet(newItem, "newItem", setChangeFields, setSaveAvailable);
                            // if (isFlowChanged) {
                            //     addDifference(cfTemp, newItem, "move", setChangeFields, setSaveAvailable);
                            // } else {
                            //     removeDifference(cfTemp, newItem, "move", setChangeFields, setSaveAvailable);
                            // }
                            // is not move and bulk
                            // setAutomDetail({
                            //     ...automDetail, items, activeItem: [{
                            //         ...newItem,
                            //         actionName: newItem.action_name,
                            //         libraryName: newItem.library_name,
                            //         libraryLabel: newItem.library_label,
                            //     }]
                            // });
                            setAutomDetail({
                                ...autom, items
                            });
                            if (isDesktopRecorder) {
                                setDesktopActiveItems([newItem])
                            }
                            else {
                                setActiveItems([{
                                    ...newItem,
                                    actionName: newItem.action_name,
                                    libraryName: newItem.library_name,
                                    libraryLabel: newItem.library_label,
                                }])
                            }

                        }
                        isEhFlow ? handleUpdate(items, undefined, undefined, "errorHistory", autom.errorHandlingId) : handleUpdate(items)
                    }
                }
                //else addableFlag = false;

                // if (addableFlag && isMove) {
                //     let modifiedItems = removeItem(item.id, items);
                //     if (bulk) items = modifiedItems;
                //     else {
                //         setAutomDetail({ ...automDetail, items: modifiedItems, activeItem: [newItem] });
                //         handleUpdate(modifiedItems);
                //     }
                // }

                if (bulk) return items;
            } else {
                return
            }
            // localStorage.removeItem("dragItem");
        }
    }, [debuggingStart, setAutomDetail]);

    const checkGotoItemIds = (gotoIds, items, rootItems, from) => {
        return new Promise(async (resolve) => {
            for (let item of items) {
                if (item?.actionName === 'GO-TO') {
                    if (item.fields && item.fields.destination?.value?.item_id) {
                        let exist = checkItemExist(item.fields.destination.value.item_id, rootItems)
                        if ((exist && from !== "delete") || (!exist && from === 'delete')) {
                            if (from === 'delete') {
                                item.fields.destination.value = {};
                            }
                            gotoIds.push({ destination: item.fields.destination.value, id: item.id });
                        }
                    } else if (from !== 'delete') {
                        gotoIds.push({ destination: {}, id: item.id });
                    }
                }

                if (item?.children && item.children.length) {
                    await checkGotoItemIds(gotoIds, item.children, rootItems, from)
                }

            }
            resolve(true);
        })
    }

    const checkItemExist = (item_id, items) => {
        let found = false;
        for (let item of items) {

            if (item?.item_id === item_id) {
                found = true;
                break;
            }

            if (item?.children && item.children.length) {
                found = checkItemExist(item_id, item.children);
                if (found) break;
            }

        }
        return found;
    }

    const deleteItem = useCallback(async (item, cut) => {
        if (debuggingStart) {
            return setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'OPERATIONS-NOT-PERMITTED-ON-DEBUGGING'), severity: 'error' }));
        }
        // let newActiveItem = [];
        // const previousOrder = item.order - 1;
        // let selectedAction = [];
        // RemoveAndActiveItem(item.id, items, selectedAction);
        let modifiedItems
        let errorHandlingId;
        await setAutomDetail((autom) => {
            errorHandlingId = autom.errorHandlingId;
            modifiedItems = JSON.parse(JSON.stringify(autom.items));

            return { ...autom };
        })
        if (Array.isArray(item)) {
            for (const i of item) {
                modifiedItems = removeItem(i.id, modifiedItems, i.action_name === 'IF');
            }
        } else {
            modifiedItems = removeItem(item.id, modifiedItems, item.action_name === 'IF');
        }

        // const previousAction = automDetail.items.find(x => x.order === previousOrder)
        // if (previousAction.actionName !== 'START') {
        //     newActiveItem = previousAction;
        // }


        // setAutomDetail({ ...automDetail, items: modifiedItems, activeItem: [] });

        changeOrder(modifiedItems, 0);
        let gotoIds = [];
        // check and update gotoActions
        await checkGotoItemIds(gotoIds, modifiedItems, modifiedItems, 'delete');
        if (gotoIds.length) {
            setActions(prev => {
                return gotoIds.reduce((yeniState, v) => {
                    // If the key does not exist, do not change it
                    if (!prev[v.id]) return yeniState;

                    // Create new state for key
                    return {
                        ...yeniState,
                        [v.id]: {
                            ...prev[v.id],
                            fields: { destination: { value: {}, type: 'ARRAY', isRequired: true } }
                        }
                    };
                }, { ...prev }); // Use old state at startup
            })
        }

        setAutomDetail((autom) => {
            return { ...autom, items: modifiedItems }
        });
        if (isDesktopRecorder) {
            // handleDeleteAction(item.id)
            setDesktopActiveItems([])
        }
        else {
            setActiveItems([])
        }
        setShowRightArea(false);
        isEhFlow ? handleUpdate(modifiedItems, undefined, undefined, "errorHistory", errorHandlingId) : handleUpdate(modifiedItems)
        if (['GROUP', 'REPEAT', 'CONDITION', 'IF', 'ELSEIF', 'ELSE'].includes(item.action_name) || item.id) {
            setDetailTabs(prev => prev.filter(i => i.errorHandling ? i.id !== item.id : i.id !== `custom_${item.id}`));
        }
        if (!cut) {
            localStorage.removeItem('dragItem');
        }

        const isFlowChanged = isJSONDifferent(modifiedItems, savedFlow)

        if (isFlowChanged) {
            setSaveAvailable(true);
        } else {
            setSaveAvailable(false);
        }

        // const tmpChangedFields = JSON.parse(JSON.stringify(changedFieldsState));
        // delete tmpChangedFields[item.id];
        setChangeFields((oldObject) => {
            const { [item.id]: _, ...rest } = oldObject;
            return rest;
        });

        // setChangeFields(tmpChangedFields);

        let activeItem = {}
        if (Array.isArray(item)) {
            activeItem = item[0];
            if (['GROUP', 'REPEAT', 'CONDITION', 'IF', 'ELSEIF', 'ELSE'].includes(item[0].action_name) || item[0].id) {
                setDetailTabs(prev => prev.filter(i => i.errorHandling ? i.id !== item[0].id : i.id !== `custom_${item[0].id}`));
            }
        } else {
            activeItem = item;
        }
        if (activeItem.libraryName === "WHATSAPP") {
            const isLibraryExist = findIfLibraryExist(modifiedItems, "WHATSAPP")
            setIsWhatsappExist(isLibraryExist);
        }
        if (activeItem.libraryName === "MICROSOFT-TEAMS") {
            const isLibraryExist = findIfLibraryExist(modifiedItems, "MICROSOFT-TEAMS")
            setIsMSTeamsExist(isLibraryExist);
        }
    }, [debuggingStart, setAutomDetail]);

    // const setActiveItem = (e, item, type = 'normal') => {
    //     if (type === 'debug') {
    //         let items = JSON.parse(JSON.stringify(automDetail.items));
    //         let active = JSON.parse(JSON.stringify(item));
    //         let modifiedItems = handleDebugIconShow(item.id, items);
    //         setAutomDetail({
    //             ...automDetail, items: modifiedItems, activeItem: [{
    //                 ...active,
    //                 actionName: active.action_name,
    //                 libraryName: active.library_name,
    //                 libraryLabel: active.library_label,
    //                 isDebugging: !active.isDebugging,
    //             }]
    //         });
    //     } else {
    //         let activeItem, exist, selected = {
    //             ...item,
    //             actionName: item.action_name,
    //             libraryName: item.library_name,
    //             libraryLabel: item.library_label,
    //         };

    //         if (e.ctrlKey) {
    //             activeItem = automDetail.activeItem.filter(i => {
    //                 if (i.id === item.id) {
    //                     exist = true;
    //                     return false;
    //                 } else return true;
    //             });
    //             if (!exist) activeItem.push(selected);
    //         } else activeItem = [selected];
    //         if (!(activeItem?.length > 0)) setShowRightArea(false);
    //         setAutomDetail({ ...automDetail, activeItem });
    //     }

    // };

    const changeScale = (e, action) => {
        if (action === 'zoom-in' && scale < 1) {
            setScale(scale + 0.15);
        } else if (action === 'zoom-out' && scale > 0.35) {
            setScale(scale - 0.15);
        }
    };

    const handleScreen = () => {
        // Center Flow
        const flow = !isDesktopRecorder ? document.getElementById(automDetail.type === "Autom" && !isEhFlow ? 'new-flow-row' : "start-container-border") :
            document.querySelector(".dialog-desktop-actions #start-container-border")
        const mainFlow = document.querySelector(`${isDesktopRecorder ? ".dialog-desktop-actions " : ""}.new-flow-drop-area-grid`)

        if (mainFlow) {
            const flowWidth = mainFlow.offsetWidth
            const dropAreaWidth = document.querySelector(`${isDesktopRecorder ? ".dialog-desktop-actions " : ""}#flow-container`)?.offsetWidth
            if (dropAreaWidth) {
                if (dropAreaWidth > flowWidth) {
                    mainFlow.style.left = `${(dropAreaWidth - (flowWidth)) / 2}px`
                }
            }
        }
        flow.scrollIntoView({
            block: "center",
            inline: "center",
        });
    }

    const handleForward = async () => {
        if (debuggingStart) {
            return setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'OPERATIONS-NOT-PERMITTED-ON-DEBUGGING'), severity: 'error' }));
        }
        const next = isEhFlow ? handleRedo("errorHistory", automDetail.errorHandlingId) : handleRedo();
        if (next) {
            let gotoIds = [];
            // check and update gotoActions
            await checkGotoItemIds(gotoIds, next, next, 'redo');
            if (gotoIds.length) {
                setActions(prev => {
                    return gotoIds.reduce((yeniState, v) => {
                        // If the key does not exist, do not change it
                        if (!prev[v.id]) return yeniState;

                        // Create new state for key
                        return {
                            ...yeniState,
                            [v.id]: {
                                ...prev[v.id],
                                fields: { destination: { value: v.destination, type: 'ARRAY', isRequired: true } }
                            }
                        };
                    }, { ...prev }); // Use old state at startup
                })
            }

            const newAutomDetail = { ...automDetail, items: next };
            changeOrder(newAutomDetail.items, 0)
            const isFlowChanged = isJSONDifferent(newAutomDetail.items, savedFlow)

            if (isFlowChanged) {
                setSaveAvailable(true);
            } else {
                setSaveAvailable(false);
            }

            if (isDesktopRecorder) {
                setDesktopActiveItems([])
            }
            else {
                setActiveItems([])
            }
            setAutomDetail(newAutomDetail);
            setIsWhatsappExist(findIfLibraryExist(next, "WHATSAPP"));
            setIsMSTeamsExist(findIfLibraryExist(next, "MICROSOFT-TEAMS"));
        }
    };

    const handleBack = async () => {
        if (debuggingStart) {
            return setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'OPERATIONS-NOT-PERMITTED-ON-DEBUGGING'), severity: 'error' }));
        }
        const prev = isEhFlow ? handleUndo("errorHistory", automDetail.errorHandlingId) : handleUndo();
        if (prev) {
            const newAutomDetail = { ...automDetail, items: prev };
            let gotoIds = [];
            // check and update gotoActions
            await checkGotoItemIds(gotoIds, prev, prev, 'undo');
            if (gotoIds.length) {
                setActions(prev => {
                    return gotoIds.reduce((yeniState, v) => {
                        // If the key does not exist, do not change it
                        if (!prev[v.id]) return yeniState;

                        // Create new state for key
                        return {
                            ...yeniState,
                            [v.id]: {
                                ...prev[v.id],
                                fields: { destination: { value: v.destination, type: 'ARRAY', isRequired: true } }
                            }
                        };
                    }, { ...prev }); // Use old state at startup
                })
            }
            changeOrder(newAutomDetail.items, 0)
            const isFlowChanged = isJSONDifferent(newAutomDetail.items, savedFlow)

            if (isFlowChanged) {
                setSaveAvailable(true);
            } else {
                setSaveAvailable(false);
            }
            if (isDesktopRecorder) {
                setDesktopActiveItems([])
            }
            else {
                setActiveItems([])
            }
            setShowRightArea(false);
            setAutomDetail(newAutomDetail);
            setIsWhatsappExist(findIfLibraryExist(prev, "WHATSAPP"));
            setIsMSTeamsExist(findIfLibraryExist(prev, "MICROSOFT-TEAMS"));
        }
    };

    const handlePaste = (isPasteInside, ctrlV) => {
        if (debuggingStart) {
            return setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'OPERATIONS-NOT-PERMITTED-ON-DEBUGGING'), severity: 'error' }));
        }
        // if (automDetail.activeItem[0] && automDetail.activeItem[0].name !== 'STOP') {
        //     let currentItem = JSON.parse(localStorage.getItem('copiedItem'))?.item;
        //     let modified = JSON.parse(JSON.stringify(automDetail.items));
        //     if (!Array.isArray(currentItem)) currentItem = [currentItem];
        //     for (const item of currentItem) {
        //         if (['REPEAT', 'GROUP', 'IF', 'ELSE'].includes(automDetail.activeItem[0]?.name)) {
        //             modified = updateItems(0, automDetail.activeItem[0].name, automDetail.activeItem[0].id, undefined, true, true, item, modified);
        //         } else {
        //             modified = updateItems(0, automDetail.activeItem[0]?.name, automDetail.activeItem[0]?.id, undefined, undefined, true, item, modified);
        //         }
        //     }
        //     if (modified) {
        //         handleUpdate(modified);
        //         setAutomDetail({ ...automDetail, items: modified });
        //     }
        // }
        let copyAutom
        setAutomDetail((autom) => {
            copyAutom = autom
            return autom
        })
        let selectedItems = isDesktopRecorder ? desktopActiveItems : activeItems
        if (selectedItems[0] && selectedItems[0].name !== 'STOP') {
            let currentItem = JSON.parse(localStorage.getItem('copiedItem'))?.item;
            // let currentItem = copiedItem?.item;
            let modified = JSON.parse(JSON.stringify(copyAutom.items));
            if (!Array.isArray(currentItem)) currentItem = [currentItem];
            for (const item of currentItem) {
                if (['REPEAT', 'GROUP', 'IF', 'ELSE', 'ELSEIF', "SCOPE"].includes(selectedItems[0]?.name) && isPasteInside) {
                    modified = updateItems(0, copyAutom, selectedItems[0].name, selectedItems[0].id, undefined, true, true, item, modified, selectedItems[0]);
                }
                else if (!isPasteInside || ctrlV) {
                    // checkGroupForPaste(selectedItems[0], modified)
                    let bulk = item?.children ? item : false;
                    modified = updateItems(0, copyAutom, selectedItems[0]?.name, selectedItems[0]?.id, undefined, undefined, true, bulk, modified, undefined, selectedItems[0]);
                }
            }
            if (modified) {
                // isEhFlow ? handleUpdate(modified, undefined, undefined, "errorHistory", copyAutom.errorHandlingId) : handleUpdate(modified)
                setAutomDetail({ ...copyAutom, items: modified });
            }

            // if (modified) {
            //     changeOrder(modified, 0);
            // }

            const isFlowChanged = isJSONDifferent(modified, savedFlow)

            if (isFlowChanged) {
                setSaveAvailable(true);
            } else {
                setSaveAvailable(false);
            }
        }
    }

    // const checkGroupForPaste = async (item, modified) => {
    //     let group = {};
    //     if (item.libraryName === 'START') {
    //         group = { children: automDetail.items }
    //     } else if (direction === '' && item.type === 'groupable') {
    //         group = item;
    //     } else {
    //         if (item.action_name === "CONDITION") {
    //             if (item.children && item.children.length) {
    //                 group = await findParentActionById(item.children[0].item_id, automDetail.items, true);
    //             }
    //         } else {
    //             group = await findParentActionById(item.item_id, automDetail.items, true);
    //         }
    //     }
    //     const modified = updateItems(0, item.name, item.id, undefined, undefined, true, undefined, undefined, group);
    //     if (modified) {
    //         handleUpdate(modified);
    //         setAutomDetail({ ...automDetail, items: modified });
    //     }
    //     if (modified) {
    //         changeOrder(modified, 0);
    //     }

    //     const isFlowChanged = isJSONDifferent(modified, savedFlow)

    //     if (isFlowChanged) {
    //         setSaveAvailable(true);
    //     } else {
    //         setSaveAvailable(false);
    //     }
    // }

    const handleDelete = () => {
        if (debuggingStart) {
            return setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'OPERATIONS-NOT-PERMITTED-ON-DEBUGGING'), severity: 'error' }));
        }

        // const activeItem = automDetail.activeItem.length > 0 ? automDetail.activeItem[0] : undefined;
        // if (activeItem && activeItem.libraryLabel !== "TRIGGERSTATIC" && activeItem.libraryLabel !== "STOP" && activeItem.actionName !== "START") {
        //     deleteItem(automDetail.activeItem);
        //     setShowRightArea(false);
        // }
        const activeItem = isDesktopRecorder ? desktopActiveItems.length > 0 ? desktopActiveItems[0] : undefined : activeItems.length > 0 ? activeItems[0] : undefined;
        if (activeItem && activeItem.libraryLabel !== "TRIGGERSTATIC" && activeItem.libraryLabel !== "STOP" && activeItem.actionName !== "START") {
            deleteItem(isDesktopRecorder ? desktopActiveItems : activeItems);
            setShowRightArea(false);
        }
    }

    const handleCut = (event) => {
        if (debuggingStart) {
            return setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'OPERATIONS-NOT-PERMITTED-ON-DEBUGGING'), severity: 'error' }));
        }

        // if (automDetail.activeItem && automDetail.activeItem.length && automDetail.activeItem[0].name !== 'STOP' && automDetail.activeItem[0].name !== 'START') {
        //     handleDragStart(event, automDetail.activeItem, true, true);
        //     deleteItem(automDetail.activeItem, true);
        // }
        const selectedItems = isDesktopRecorder ? desktopActiveItems : activeItems
        if (selectedItems[0].library_label === "DESKTOPACTIONS") {
            return setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'DESKTOP-ACTIONS-CANNOT-BE-COPY'), severity: 'error' }));
        }
        if (selectedItems[0].children && selectedItems[0].children.length) {
            const childDesktopAction = findChildDesktopActionById(selectedItems[0].children)
            if (childDesktopAction?.actionName) {
                return setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'GROUPABLE-ACTIONS-CANNOT-BE-COPY-WHILE-HAS-CHILD-DESKTOP-ACTIONS'), severity: 'error' }));
            }
        }
        if (selectedItems && selectedItems.length && selectedItems[0].name !== 'STOP' && selectedItems[0].name !== 'START') {
            handleDragStart(event, selectedItems, undefined, true);
            deleteItem(selectedItems, true);
        }
    }

    const handleCopy = (event) => {
        const selectedItems = isDesktopRecorder ? desktopActiveItems : activeItems
        if (selectedItems[0].library_label === "DESKTOPACTIONS") {
            return setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'DESKTOP-ACTIONS-CANNOT-BE-COPY'), severity: 'error' }));
        }
        if (selectedItems[0].children && selectedItems[0].children.length) {
            const childDesktopAction = findChildDesktopActionById(selectedItems[0].children)
            if (childDesktopAction?.actionName) {
                return setAlert(alert => ({ ...alert, show: true, message: t(ruleLabel + 'GROUPABLE-ACTIONS-CANNOT-BE-COPY-WHILE-HAS-CHILD-DESKTOP-ACTIONS'), severity: 'error' }));
            }
        }
        if (selectedItems && selectedItems.length && (selectedItems[0].actionName !== "START" && selectedItems[0].actionName !== "STOP")) {
            handleDragStart(event, selectedItems[0], undefined, true);
            setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.AUTOMS.AUTOM-COPIED'), severity: 'success' }));
            return
        }
        setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.AUTOMS.AUTOM-SHOULD-COPIED'), severity: 'info' }));
    }

    function handleKeyDown(event) {
        const actionLabelInputAcive = document.querySelector(".action-item-label-input")
        if (actionLabelInputAcive) {
            return
        }
        let charCode = String.fromCharCode(event.which).toLowerCase();
        if (event.ctrlKey && event.shiftKey && charCode === 'v') {
        } else if (event.ctrlKey && charCode === 'v') {
            handlePaste(true, true);
        } else if (event.keyCode === 46) {
            handleDelete();
        } else if (event.ctrlKey && charCode === 'x') {
            handleCut(event);
        } else if (event.ctrlKey && charCode === 'c') {
            handleCopy(event);
        } else {
            return;
        }
    }

    const GotoAction = useCallback(async (e, newValue, isErrorFlow) => {
        if (newValue) {
            let copyAutomDetail
            setMainAutomDetail((autom) => {
                copyAutomDetail = JSON.parse(JSON.stringify(autom))
                return autom
            })
            let copyItem = await findActionById(newValue.item_id, copyAutomDetail.items);
            if (!copyItem) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: "Action not found please try again",
                    severity: 'error'
                }));
                return
            }
            if (isEhFlow) {
                setTabFilter(0)
            }
            setActiveItem(e, copyItem, "INPUT-SELECT");
        } else {
            setActiveItem(e, []);
        }
    }, [setAutomDetail, isEhFlow]);

    const handleDragLeave = (e) => {
        if (e?.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (e?.target) {
            e.target.style.borderColor = 'transparent';
            if (e.target.previousSibling?.firstChild) {
                // After the drop process is finished, the + icon is made to be clickable again.
                e.target.previousSibling.firstChild.firstChild.style.zIndex = "";
            }
        }
    };

    const handleOnDrop = useCallback(async (e, item, index, direction, isFirstChild, copy, previewItem, isCondition) => {
        let copyAutom
        setAutomDetail((autom) => {
            copyAutom = autom
            return autom
        })
        let group = {};
        // item => previewItem
        if (item.libraryName === 'START') {
            group = { children: copyAutom.items }
        } else if (direction === '' && item.type === 'groupable') {
            group = item;
        } else {
            if (item.action_name === "CONDITION") {
                if (item.children && item.children.length) {
                    group = await findParentActionById(item.children[0].item_id, copyAutom.items, true);
                }
            } else {
                group = await findParentActionById(item.item_id, copyAutom.items, true);
            }
        }
        if (e?.stopPropagation) e.stopPropagation();
        if (e?.preventDefault) e.preventDefault();
        const isUpdate = updateItems(index, copyAutom, item.name, item.id, direction, isFirstChild, copy, undefined, undefined, group);
        if (!isUpdate) {
            handleDragLeave(e)
            handleDragEnd()
        }
        handleDragEnd()
    }, [debuggingStart, setAutomDetail]);

    const setTriggerType = useCallback(async (type) => {
        let integrationType = "";
        let newFormData = {
            autom_id: automDetail.id,
            updatingFields: [
                // { field_name: "name", field_value: automDetail.name },
                // { field_name: "description", field_value: automDetail.description },
                // { field_name: "autom_group_id", field_value: automDetail.autom_group_id },
                // { field_name: "mate_id", field_value: automDetail.mateId },
                // { field_name: "queue_enabled", field_value: automDetail.queue_enabled },
                // { field_name: "qpool_id", field_value: automDetail.queuePool },
                { field_name: "trigger_type", field_value: type }
            ]
        };

        if (type === "webhook" || type === "app" || type === "api" || type === "email") {
            integrationType = "TRIGGER";
        } else if (type === "schedule") {
            integrationType = "SCHEDULE";
        }

        newFormData.updatingFields.push({
            field_name: "integration_type",
            field_value: integrationType
        })
        // Sending Trigger datas to service and get response
        const response = await AutomService.updateAutom(
            newFormData,
            automDetail.id
        );

        if (response.status) {
            let triggerSelectionData = [type];
            handleTrigger(type, integrationType)

            // setTriggerSelectionData(triggerSelectionData);
            setReCheck((pre) => !pre);
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(triggerStaticTriggerLabel + "TRIGGER-TYPE-SELECTED"),
                severity: 'success'
            }));

            // if integration type is a webhook or api, run function automaticallyVariableCreation
            if (type === "webhook" || type === "api") {
                automaticallyVariableCreation(type);
            }
            // setOpenSetTriggerType(false);
            return triggerSelectionData
        } else {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(triggerStaticTriggerLabel + "TRIGGER-TYPE-SELECTION-FAILED"),
                severity: 'error'
            }));
        }
    }, [])

    return (
        <>
            {!isDesktopRecorder &&
                <>
                    {/* <button onClick={handleDiagramBuilder} className="diagram-flow-button">
                        <img src={DiagramIcon} alt="" />
                        <span>{t('CONTENT.FLOW.DIAGRAM')}</span>
                    </button>
                    <button onClick={handleRoi} className="diagram-flow-button roi-button">
                        <img src={RoiIcon} alt="" />
                        <span>{t('CONTENT.FLOW.ROI')}</span>
                    </button> */}
                </>
            }

            <ShortCutSection changeScale={changeScale} onForward={handleForward} onBack={handleBack}
                onDelete={handleDelete} onCut={handleCut} onCopy={handleCopy} onPaste={handlePaste}
                handleExport={handleExport} handleImport={handleImport} handleSlowMotion={handleSlowMotion}
                isDebuggingExpand={debuggingExpand} setDebuggingExpand={setDebuggingExpand}
                isDebugging={debuggingStart} openRunningModal={openRunningModal} handleScreen={handleScreen} isDesktopRecorder={isDesktopRecorder}
            />


            <div id="flow-container" onDragOver={e => e.preventDefault()} onDrop={handleDrop} className={`drop-container ${devMode ? "dev-mode-drop-container" : ""}`}
                onDragEnd={handleDragEnd}>
                {
                    !openTriggerConfigure && (
                        <div id="new-flow-drop-area-grid" className="new-flow-drop-area-grid"
                            style={{ transform: `scale(${scale})` }}
                            tabIndex="0" onKeyDown={handleKeyDown} onDragStart={handleDrag} draggable>
                            {automDetail.items &&
                                automDetail.items.map((item, index) => (
                                    !item?.hidden && item.name !== `${isDesktopRecorder ? "TRIGGER" : false}` &&
                                    < Item key={item.id} item={item} index={index} count={automDetail.items.length}
                                        setDetailTabs={setDetailTabs} debuggingStart={debuggingStart}
                                        handleDragStart={handleDragStart}
                                        setActiveItem={setActiveItem} setDialog={setDialog}
                                        deleteItem={deleteItem} isConditionChild={false}
                                        isFocused={isFocused} detailTabs={detailTabs}
                                        isEhFlow={isEhFlow}
                                        GotoAction={GotoAction}
                                        handleOnDrop={handleOnDrop}
                                        setTriggerType={setTriggerType}
                                        handleTrigger={handleTrigger}
                                        handleErrorOpenClick={handleErrorOpenClick}
                                        handleErrorCloseClick={handleErrorCloseClick}
                                        setShowTriggerRightArea={setShowTriggerRightArea}
                                        setOpenTriggerConfigure={setOpenTriggerConfigure}
                                        setTriggerOffSet={setTriggerOffSet}
                                        setReCheck={setReCheck}
                                        openResetTriggerConfiguration={openResetTriggerConfiguration}
                                        automaticallyVariableCreation={automaticallyVariableCreation}
                                        setTriggerModal={setTriggerModal} setOpenSchedule={setOpenSchedule}
                                        automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation}
                                        getVariables={getVariables}
                                        updateVariableByItemId={updateVariableByItemId} isDesktopRecorder={isDesktopRecorder}
                                        desktopActionsEditDialog={desktopActionsEditDialog}
                                        changeLabelField={changeLabelField}
                                        resetWPSession={resetWPSession}
                                        setActions={setActions}
                                        handleOpenErrorHandlingAutom={handleOpenErrorHandlingAutom}
                                    />
                                ))}
                        </div>
                    )}

            </div>
            {
                triggerOffSet && (
                    <TriggerModal automId={automDetail.id} automVersionId={automDetail.versionId}
                        openTriggerConfigure={openTriggerConfigure} setAutomDetail={setAutomDetail}
                        setOpenTriggerConfigure={setOpenTriggerConfigure} triggerOffSet={triggerOffSet}
                        variables={variables} setOpenVariable={setOpenVariable}
                        automDetail={automDetail} setTriggerDetail={setTriggerDetail} reCheck={reCheck} setReCheck={setReCheck} />
                )
            }
            {dialog && <TabDialog open={dialog} setOpen={setDialog} detailTabs={detailTabs} setDetailTabs={setDetailTabs} />}
        </>
    );
});
export default DropArea;
